import { render, staticRenderFns } from "./ServerIsDown.vue?vue&type=template&id=6a75878b&scoped=true&"
import script from "./ServerIsDown.vue?vue&type=script&lang=ts&"
export * from "./ServerIsDown.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=6a75878b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a75878b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VIcon,VMain})
